import { ChangeDetectorRef, Component, ElementRef, Renderer2 } from "@angular/core";
import { DomHandler } from "@bfx/primeng/dom";
import { BfxMultiSelectorComponent } from "../bfx-element-library/bfx-multi-selector.component";
import { BfxFindFilterSelectorService } from "./bfx-find-filter-selector.service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-find-filter-selector",
  templateUrl: "./html/bfx-find-filter-selector.html",
  standalone: false,
})
export class BfxFindFilterSelectorComponent extends BfxMultiSelectorComponent {
  constructor(
    myElement: ElementRef,
    selectorService: BfxFindFilterSelectorService,
    domHandler: DomHandler,
    renderer: Renderer2,
    cd: ChangeDetectorRef,
  ) {
    super(myElement, selectorService, domHandler, renderer, cd);

    this.panelStyleClass = "bfx-find-filter-selector-dropdown";
  }
}
